import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useAppDispatch } from 'hooks/reduxHooks'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { pushWithRegion } from 'actions/NavigationActions'
import LoyaltyEsimDetailsContent from './LoyaltyEsimDetailsContent'

interface LoyaltyEsimDetailsModalProps {
  /** When set (e.g. from order/booking-confirmation Redeem), show only this order's code (single-code variation). */
  orderId?: string
}

function LoyaltyEsimDetailsModal({ orderId }: LoyaltyEsimDetailsModalProps) {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const { resolve } = useModalElementContext()

  const handleViewOrder = useCallback((orderIdToView: string) => {
    resolve()
    dispatch(pushWithRegion(`/account/my-escapes/order/${orderIdToView}`))
  }, [resolve, dispatch])

  return (
    <ModalBase size="L">
      <ModalHeader title={intl.formatMessage({
        id: 'JQiTXySxKAe5wYCZyzLz',
        defaultMessage: 'Free Data Roaming',
        description: 'Title heading for the eSIM details and redemption modal dialog',
      })}
      />
      <ModalBody>
        <LoyaltyEsimDetailsContent orderId={orderId} onViewOrder={handleViewOrder} />
      </ModalBody>
    </ModalBase>
  )
}

export default LoyaltyEsimDetailsModal
